import {useTranslation} from "react-i18next";
import React from "react";

const AiEasyBlock = () => {
    const { t } = useTranslation();
    return (
        <div className="ai-easy-block">
            <img src="/images/info.png" alt="AI Info" className="ai-easy-img" />
            <div className="ai-easy-title">{t('subscription.aiLearningEasy')}</div>
            <ul className="ai-easy-list">
                <li className="ai-easy-list-item">✅ {t('subscription.noExperienceNeeded')}</li>
                <li className="ai-easy-list-item">✅ {t('subscription.noDegreeRequired')}</li>
                <li className="ai-easy-list-item">✅ {t('subscription.learnAnytime')}</li>
            </ul>
        </div>
    );
};

export default AiEasyBlock
